import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin, Workflow, LinkIcon, Facebook } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  
  return (
    <footer className="border-t bg-background/80">
      <div className="container py-10 grid gap-8 md:grid-cols-3">
        <div>
          <h3 className="text-lg font-semibold">MagicDoor</h3>
          <p className="mt-2 text-sm text-muted-foreground">
            {t('footer.description')}
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold">{t('footer.visit')}</h4>
          <a 
            href="https://www.google.com/maps/search/?api=1&query=Bulevard+General+Nicolae+Dascalescu+nr+6B" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mt-2 text-sm text-muted-foreground hover:text-primary flex items-start gap-2 transition-colors"
          >
            <MapPin className="size-4 mt-0.5" /> Bulevard General Nicolae Dascalescu, nr 6B
          </a>
          <a href="tel:+40728874582" className="mt-2 flex items-center gap-2 text-sm story-link">
            <Phone className="size-4"/> 0728 874 582
          </a>
        </div>
        <div>
          <h4 className="text-sm font-semibold">{t('footer.follow')}</h4>
          <div className="mt-2 flex items-center gap-3 text-sm">
            <a href="https://www.instagram.com/magicdoor.ro/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-primary inline-flex items-center gap-2">
              <Instagram className="size-4"/> {t('footer.instagram')}
            </a>
            <a href="https://www.tiktok.com/@magicdoor1999" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="hover:text-primary inline-flex items-center gap-2">
              <LinkIcon className="size-4"/> {t('footer.tiktok')}
            </a>
            <a href="https://www.facebook.com/magicdoor.ro" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-primary inline-flex items-center gap-2">
              <Facebook className="size-4"/> {t('footer.facebook')}
            </a>
          </div>
        </div>
      </div>
      <div className="border-t">
        <div className="container py-4 text-xs text-muted-foreground flex items-center justify-between">
          <span>© {new Date().getFullYear()} {t('footer.copyright')}</span>
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="story-link"
          >
            {t('footer.back.top')}
          </button>
        </div>
      </div>
    </footer>
  );
}
